module.exports = __webpack_public_path__ + "img/08.df65b198.png";